var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[{ sm: _vm.sm }, { 'h-100': !!_vm.title }, { container: _vm.containerMode || !!_vm.pageTitle }]},[_c('div',{class:[
            'card-container',
            { 'card-space-between': _vm.spaceBetween },
            { 'normal-mode': !!_vm.title },
            { 'page-mode': !!_vm.pageTitle },
            { dark: _vm.theme == _vm.THEMES.DARK },
        ]},[(_vm.title)?_c('div',[_c('div',{staticClass:"header-title"},[_c('div',{staticClass:"title mb-3"},[_vm._v(_vm._s(_vm.title))]),_vm._t("headerside")],2)]):_vm._e(),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }